import {
  getProductList,
  saveProductAPI,
  deleteProductAPI,
  getProductListCombo
} from '../../../services/Issues/IssueService';

export const fetchProduct = async () => {
  try {
    const response = await getProductList();

    if (response && response.success) {
      return response.data || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching product',
        variant: 'error'
      });
      console.log('Error fetching product:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching product',
      variant: 'error'
    });
    console.log('Error fetching product:', err);
    return [];
  }
};

export const fetchProductListCombo = async () => {
  try {
    const response = await getProductListCombo();

    if (response && response.success) {
      return response.data || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching product combo',
        variant: 'error'
      });
      console.log('Error fetching product:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching product',
      variant: 'error'
    });
    console.log('Error fetching Areas:', err);
    return [];
  }
};

export const saveProduct = async (payload, customSuccessMsg, customErrorMsg) => {
  try {
    const response = await saveProductAPI(payload);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to save product');
      window.showSnackbar({
        message: customErrorMsg || `Failed to save product`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `product saved successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage = err?.message || (typeof err === 'string' ? err : 'Failed to save product');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to save product:', err);
    return { success: false, message: errorMessage };
  }
};

export const deleteProduct = async (productGUID, customSuccessMsg, customErrorMsg) => {
  try {
    const response = await deleteProductAPI(productGUID);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to delete product');
      window.showSnackbar({
        message: customErrorMsg || `Failed to delete product`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `product deleted successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage =
      err?.message || (typeof err === 'string' ? err : 'Failed to delete product');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to delete product:', err);
    return { success: false, message: errorMessage };
  }
};
